import { FooterStyle } from './styles/Footer.sytle'

export default function Footer() {
  return (
    <FooterStyle>
      <p>&copy; 2023 Spadesy. All rights reserved</p>
    </FooterStyle>
  )
}
